module.exports = __webpack_public_path__ + "img/cpc.28c58b4d.jpg";